import { FileWithHandle } from 'browser-fs-access';
import { authFetch } from 'src/authFetch';

//TODO: name should be replaced by result from header
async function downloadFile(response: Response, name: string): Promise<string> {
  if(!response.ok) {
    throw new Error(response.statusText);
  }

  const filename = name.split('_')[0] + '.docx';
  const data = await response.blob();

  const url = URL.createObjectURL(data);
  const a = document.createElement('a');
  document.body.appendChild(a);

  a.href = url;
  a.download = filename;
  a.setAttribute('style', 'display: none');
  a.click();

  window.URL.revokeObjectURL(url);
  a.remove();

  return "";
}

async function listReports(files: FileWithHandle[]) {
  const reportInfo: any[] = [];
  await Promise.all(files.map(async (file) => {
    reportInfo.push(JSON.parse(await file.text()));
  }));
  return reportInfo;
}

export async function generateReport(files: FileWithHandle[], specificPath: string, msalInstance: any): Promise<string> {
  const result = await listReports(files);

  return authFetch('/api/generate' + specificPath, [...result], msalInstance)
    .then((response) => downloadFile(response, files[0].name));
}